function initialize() {
  // your bundle keywords and images
  const bundleDefs = [
    { keyword: 'Baking Bundle',   src: 'https://i.postimg.cc/bJBL5njL/Baking-Bundle.png'   },
    { keyword: 'Immunity Bundle', src: 'https://i.postimg.cc/zvNw6FcC/Immunity-Bundle.png' },
    { keyword: 'Everyday + Boost', src: 'https://i.postimg.cc/VLYBF4M1/Everyday-Boost.png' },
    { keyword: 'Ultimate Wellness Bundle', src: 'https://i.postimg.cc/9XpcDtjs/Ultimate-Wellness-Bundle.png' },
    { keyword: 'Beauty Bundle', src: 'https://i.postimg.cc/c1T8dWgy/Beauty-Bundle.png' },
  ];

  document.querySelectorAll('.rebuy-cart__flyout-item').forEach(item => {
    var titleEl = item.querySelector('.rebuy-cart__flyout-item-product-title');
    
    // Skip if the title is "Bamboo Beauty Bundle"
    if (titleEl && titleEl.textContent === 'Bamboo Beauty Bundle') {
      return; // Skip this item
    }

    if (!titleEl) return; // If no title, skip it

    const titleText = titleEl.textContent.trim();

    // Try each definition
    bundleDefs.forEach(def => {
      if (titleText.includes(def.keyword)) {
        // 1) Swap in the right image
        const img = item.querySelector('.rebuy-cart__flyout-item-media img');
        if (img) {
          img.src = def.src;
          img.alt = def.keyword;
        }

        // 2) Fully disable all links
        item.querySelectorAll('a, button').forEach(el => {
          el.removeAttribute('href');
        });
      }
    });
  });
}

(function() {
  const SELECTOR = '.rebuy-cart__flyout-item';
  function ready(fn) {
    if (document.querySelector(SELECTOR)) fn();
    else setTimeout(() => ready(fn), 100);
  }
  ready(initialize);

  new MutationObserver(muts => {
    if (muts.some(m => m.addedNodes.length)) setTimeout(initialize, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();






function disableBundleLinks() {
  const cartItems = document.querySelectorAll('.cart-item__details_cart_page');

  const bundleNames = [
    "Baking Bundle",
    "Immunity Bundle",
    "Everyday + Boost",
    "Ultimate Wellness Bundle",
    "Beauty Bundle"
  ];

  cartItems.forEach(item => {
    const productNameElement = item.querySelector('.cart-item__name');
    
    if (productNameElement && bundleNames.some(name => productNameElement.textContent.toLowerCase().includes(name.toLowerCase()))) {
      const productLink = item.querySelector('a.cart-item__name');

      if (productLink) {
        productLink.removeAttribute('href');  
        productLink.addEventListener('click', function(event) {
          event.preventDefault();  
        });
      }

      const quantityInput = item.querySelector('.quantity__input');
      if (quantityInput) {
        quantityInput.setAttribute('disabled', 'true');  
      }
    }
  });
}

if (window.location.pathname === '/cart') {
  disableBundleLinks();

  const observer = new MutationObserver(() => {
    disableBundleLinks(); 
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

function disableLinksDefaultByKeywords() {
  const keywords = [
    'Baking Bundle',
    'Immunity Bundle',
    'Everyday + Boost',
    'Ultimate Wellness Bundle',
    'Beauty Bundle'
  ];

  document.querySelectorAll('.cart-item__name').forEach(item => {
    keywords.forEach(keyword => {
      if (item.textContent.includes(keyword)) {
        item.style.pointerEvents = 'none';
      }
    });
  });
}

// Only run the code if the current path is '/cart'
if (window.location.pathname === '/cart') {
  const observer = new MutationObserver(() => {
    disableLinksDefaultByKeywords();
  });

  observer.observe(document.body, {
    childList: true, 
    subtree: true   
  });

  // Initial check to disable links if they exist when the script runs
  disableLinksDefaultByKeywords();
}
